export default typeof window === 'undefined' ? undefined : window;
